import { inject, Injectable } from '@angular/core';
import { ConnectionService } from '@catch/services';
import { filter, Observable, switchMap, take } from 'rxjs';

@Injectable()
export class OfflineInterceptor {
  private connectionService = inject(ConnectionService);

  intercept(req, next): Observable<any> {
    return this.connectionService.connected$.pipe(
      filter((isConnected) => !!isConnected),
      take(1),
      switchMap(() => next.handle(req))
    );
  }
}
